import { createSlice } from '@reduxjs/toolkit'
import axios from '../axios';
import {setBootstrapped, setOverQuota} from "./coreSlice";
import {showLinkingDiscord, showOverQuota, showHelp} from './modalsSlice';

const notificationsSlice = createSlice({
	name: 'notifications',
	initialState: {
		zones: [],
		alerts: [],
		activeZoneId: null
	},
	reducers: {
		zoneAdded(state, action) {
			state.zones.unshift(action.payload);
		},
		zoneRemoved(state, action) {
			const index = state.zones.findIndex(n => n.zone_id === action.payload);
			state.zones.splice(index, 1);
		},
		zoneEdited(state, action) {
			state.zones = state.zones.map(n => n.zone_id === action.payload.zone_id ? action.payload : n);
		},
		zonesFetched(state, action) {
			state.zones = action.payload;
		},

		setActiveZoneId(state, action) {
			state.activeZoneId = action.payload;
		},

		alertAdded(state, action) {
			state.alerts.push(action.payload);
		},
		alertRemoved(state, action) {
			const index = state.alerts.findIndex(n => n.alert_id === action.payload);
			state.alerts.splice(index, 1);
		},
		alertEdited(state, action) {
			return {...state, alerts: state.alerts.map(n => n.alert_id === action.payload.alert_id ? {...action.payload} : n)};
		},
		alertsFetched(state, action) {
			state.alerts = action.payload;
		},

	}
});

export const { zoneAdded, zoneEdited, zoneRemoved, zonesFetched, setActiveZoneId, alertAdded, alertEdited, alertRemoved, alertsFetched }
	= notificationsSlice.actions;

export const bootstrap = () => dispatch => {
	axios.get("/mod/pokemon/notifications/ajax/bootstrap.php").then(results => {
		if( results.data.error ) {
			console.log("TODO ERROR: ", results.data);
			if( results.data.linkDiscord )
				dispatch(showLinkingDiscord(results.data.linkDiscord));
		} else {
			dispatch(zonesFetched(results.data.zones));
			dispatch(alertsFetched(results.data.alerts));
			dispatch(setBootstrapped(true));
			if( results.data.zones.length > 0 )
				dispatch(setActiveZoneId(results.data.zones[0].zone_id));
			if( results.data.overQuota ) {
				dispatch(setOverQuota(results.data.overQuota));
				dispatch(showOverQuota(true));
			}

			if( !document.cookie.match(/FirstAlerts/) ) {
				dispatch(showHelp(true));
				document.cookie = "FirstAlerts=true; expires=Mon, 31 Dec 2040 23:59:59 GMT";
			}
		}
	}).catch(error => {
		console.log("TODO Failure: ", error);
	});
};

export const fetchNumSpawnpoints = (zoneId) => dispatch => {
	axios.post("/mod/pokemon/notifications/ajax/fetch-spawnpoint-count.php", { zone_id: zoneId }).then(results => {
		dispatch(zoneEdited(results.data));
	}).catch(error => {
		console.log("TODO Failure: ", error);
	});
};

export const addZone = (name, latitude, longitude, radius) => dispatch => {
	dispatch(setBootstrapped(false));
	axios.post("/mod/pokemon/notifications/ajax/save-zone.php", {
		name: name, latitude: latitude, longitude: longitude, radius: radius
	}).then(results => {
		if( results.data.error ) {
			console.log("TODO ERROR: ", results.data);
		} else {
			dispatch(zoneAdded(results.data));
			dispatch(setActiveZoneId(results.data.zone_id));
			dispatch(setBootstrapped(true));
			dispatch(fetchNumSpawnpoints(results.data.zone_id));
		}
	}).catch(error => {
		console.log("TODO Failure: ", error);
	});
};

export const deleteZone = (zoneId) => (dispatch, getState) => {
	dispatch(setBootstrapped(false));
	axios.post("/mod/pokemon/notifications/ajax/delete-zone.php", {zone_id: zoneId}).then(results => {
		if( results.data.error ) {
			console.log("TODO ERROR: ", results.data);
		} else {
			dispatch(zoneRemoved(zoneId));
			const state = getState();
			console.log("Deleting, state=", state);
			if( zoneId === state.notifications.activeZoneId )
				dispatch(setActiveZoneId(state.notifications.zones[0].zone_id))
			dispatch(setBootstrapped(true));
		}
	}).catch(error => {
		console.log("TODO Failure: ", error);
	});
};

export const addAlert = (zone, pokemonIds, minQuality, minIv, startTime, endTime, paused) => dispatch => {
	axios.post("/mod/pokemon/notifications/ajax/save-alert.php", {
		zone_id: zone.zone_id,
		pokemon_ids: pokemonIds.map(p => p.value).join(','),
		min_quality: minQuality,
		min_iv: minIv,
		start_time: startTime,
		end_time: endTime,
		paused: paused
	}).then(results => {
		if( results.data.error ) {
			console.log("TODO ERROR: ", results.data);
		} else {
			dispatch(alertAdded(results.data));
		}
	}).catch(error => {
		console.log("TODO Failure: ", error);
	});
};

export const editAlert = (alert, pokemonIds, minQuality, minIv, startTime, endTime, paused) => dispatch => {
	axios.post("/mod/pokemon/notifications/ajax/save-alert.php", {
		alert_id: alert.alert_id,
		pokemon_ids: pokemonIds.map(p => p.value).join(','),
		min_quality: minQuality,
		min_iv: minIv,
		start_time: startTime,
		end_time: endTime,
		paused: paused
	}).then(results => {
		if( results.data.error ) {
			console.log("TODO ERROR: ", results.data);
		} else {
			dispatch(alertEdited(results.data));
		}
	}).catch(error => {
		console.log("TODO Failure: ", error);
	});
};

export const deleteAlert = (alertId) => dispatch => {
	dispatch(setBootstrapped(false));
	axios.post("/mod/pokemon/notifications/ajax/delete-alert.php", {alert_id: alertId}).then(results => {
		if( results.data.error ) {
			console.log("TODO ERROR: ", results.data);
		} else {
			dispatch(alertRemoved(alertId));
			dispatch(setBootstrapped(true));
		}
	}).catch(error => {
		console.log("TODO Failure: ", error);
	});
};

export default notificationsSlice.reducer;